<template>
    <div>
        <BTabs>
            <BTab :title="$t('components.addComplimentary')">
                <AddEshantion/>
            </BTab>
            <BTab :title="$t('components.complimentaryList')">
                <EshantionList/>
            </BTab>
        </BTabs>


    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Vue from "vue";

    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import BTab from "../../tabs/BTab";
    import BTabs from "../../tabs/BTabs";
import AddEshantion from "./AddEshantion";
import EshantionList from "./EshantionList";



    export default {
        name: 'Login',
        components: {
            BTabs,
            BTab,
            Treeselect,
            AddEshantion,
            EshantionList,

        },
        data() {
            return {

            }
        },
        mounted() {
            this.$root.root_validate_errors = [];

        },
        watch: {

        },
        methods: {

        }
    }

</script>
